(function () {
  var DEFAULT_SCORE = 5;

  function openOverlay(trigger) {
    var $ = window.jQuery;
    var modal = document.getElementById('star_raiting_modal');
    var target = document.getElementById('star_raiting');
    var url = trigger.getAttribute('data-overlay-url');
    var productId = trigger.getAttribute('data-product-id');

    if (!$ || !modal || !target || !url || !productId) {
      return;
    }

    $(modal).modal('show');

    $.get(url, { value: DEFAULT_SCORE, product_id: productId, hash_code: '' }, function (data) {
      $(target).html(data);
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('.js-add-review') : null;

    if (!trigger) {
      return;
    }

    event.preventDefault();
    openOverlay(trigger);
  });
})();
